function Skeleton() {
  return (
    <div className="grid animate-pulse gap-4 md:grid-cols-2">
      {Array(6)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className="rounded-2xl border border-gray-200 p-4 dark:border-gray-700"
          >
            <div className="mb-3 flex items-center gap-2">
              <div className="h-6 w-11 rounded-full bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-5 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
            <div className="space-y-3 border-t border-gray-200 pt-3 dark:border-gray-700">
              {Array(3)
                .fill(0)
                .map((_, j) => (
                  <div key={j} className="flex items-center gap-2">
                    <div className="h-5 w-10 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                    <div className="h-4 w-28 rounded bg-gray-200 dark:bg-gray-700"></div>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
}

export default Skeleton;
